import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { GridMainFilter, GridSelection, SelectionMode } from '../../core/shared/grid/grid.model';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { HolidayCalendarRest } from './holiday-calendar.rest';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRest } from '../../login/login.rest';
import { DialogService } from '../../core/shared/dialog/dialog.service';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { DateInputModel } from '../../core/shared/date-input/date-input.model';
import { HolidayCalendar } from './holiday-calendar.model';
import { NgForm } from '@angular/forms';
import { ModalComponent } from '../../core/shared/modal/modal.component';

@Component({
  selector: 'app-holiday-calendar',
  templateUrl: './holiday-calendar.component.html',
  styleUrls: ['./holiday-calendar.component.scss']
})
export class HolidayCalendarComponent extends GridSelection implements OnInit, HasPermissions {
  permissions: Permissions;
  public path: string;
  public hideToggles: boolean;
  public expanded: boolean;
  public editedItemId: any;

  private selectedYear: number = new Date().getFullYear();
  private selectedMonth: number = null;
  private years: number[] = [2019, 2020, 2021];
  private months: { name: string, value: number }[] = [
    { name: "Styczeń", value: 1 },
    { name: "Luty", value: 2 },
    { name: "Marzec", value: 3 },
    { name: "Kwiecień", value: 4 },
    { name: "Maj", value: 5 },
    { name: "Czewiec", value: 6 },
    { name: "Lipiec", value: 7 },
    { name: "Sierpień", value: 8 },
    { name: "Wrzesień", value: 9 },
    { name: "Październik", value: 10 },
    { name: "Listopad", value: 11 },
    { name: "Grudzień", value: 12 }];

  public isEditable: boolean = false;
  public isAdd: boolean = false;
  public isRemovable: boolean = false;

  private isRestoredMainFilterDate: boolean = false;
  private mainFilter: GridMainFilter[];
  public fromDate: DateInputModel;
  public toDate: DateInputModel;
  public addDate: DateInputModel;
  public descriptionText: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginRest: LoginRest,
    private rest: HolidayCalendarRest,
    public dialog: DialogService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private permissionService: PermissionsService) {

    super();
    this._grid = this.grid;
    this.onResize();
  }

  @ViewChild('holidayCalendarForm') holidayCalendarForm: NgForm;
  @ViewChild(ModalComponent) private modal: ModalComponent;
  @ViewChild(GridComponent) grid: GridComponent;

  private headers = [
    { displayName: 'Data', propertyName: 'date', propertyType: 'date' },
    { displayName: 'Nazwa', propertyName: 'description', propertyType: 'string' },
    { displayName: 'Dzień', propertyName: 'dayName', propertyType: 'string' }
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'Dodaj domyślne daty dla roku', class: "btn-success", icon: '', onClick: () => { this.addDefaultsDatesForYear() }, enabled: true, isForSelected: false }
  ];

  ngOnInit() {
    this.spinnerService.show();
    this.selectionMode = SelectionMode.none;
    this.mainFilter = new Array();
    this.setUpYears();
    this.setPermissions('HolidayCalendar');
    this.setUpDates()
    this.path = `api/holidaycalendar/grid`;
  }

  ngAfterViewInit() {
    this._grid = this.grid;
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setUpYears() {
    var minyear = 2000;
    this.years = new Array();
    this.years.push(minyear);
    for (var i = 1; i <= 100; i++) {
      var newYear = minyear + i;
      this.years.push(newYear);
    }
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
    this.isEditable = this.selectionMode === SelectionMode.none && (this.permissions.canEdit || this.permissions.canShow);
    this.isRemovable = this.selectionMode === SelectionMode.none && this.permissions.canDelete;
    this.isAdd = this.selectionMode === SelectionMode.none && this.permissions.canAdd;
  }

  private setUpDates() {
    this.fromDate = new DateInputModel();
    this.fromDate.isReadOnly = false;
    this.fromDate.isRequired = false;
    this.fromDate.name = 'Od:';
    this.fromDate.value = new Date();
    this.fromDate.value.setDate(1);
    this.fromDate.valueStr = this.fromDate.value.toDateString();
    this.fromDate.internalName = 'FromDate';

    this.toDate = new DateInputModel();
    this.toDate.isReadOnly = false;
    this.toDate.isRequired = false;
    this.toDate.name = 'Do:';
    this.toDate.value = new Date();
    this.toDate.value.setHours(23, 59, 59, 0);
    this.toDate.valueStr = this.toDate.value.toDateString();
    this.toDate.withTime = false;
    this.toDate.internalName = 'ToDate';
    //to add
    this.addDate = new DateInputModel();
    this.addDate.isReadOnly = false;
    this.addDate.isRequired = false;
    this.addDate.name = 'Do:';
    this.addDate.value = new Date();
    this.addDate.valueStr = this.toDate.value.toDateString();
    this.addDate.withTime = false;
    this.addDate.internalName = 'AddDate';
  }

  private setFiltersFromRestoredData() {
    if (this.grid.mainFilter != null) {
      const fromDate = this.findFilter('FromDate');
      if (fromDate != null) {
        this.fromDate.value = new Date(fromDate);
      }
      const toDate = this.findFilter('ToDate');
      if (toDate != null) {
        this.toDate.value = new Date(toDate);
      }
    }
  }

  private onDateValidation(date: DateInputModel, isValid: boolean) {
    if (!date) {
      return;
    }
    if (date.internalName === 'FromDate' && this.fromDate.value > this.toDate.value) {
      this.toDate.value = new Date(date.value);
      this.toDate.value.setHours(23, 59, 59, 0);
    }
    if (date.internalName === 'ToDate' && date.value < this.fromDate.value) {
      if (date.value != null) {
        this.fromDate.value = new Date(date.value);
        this.fromDate.value.setHours(0, 0, 0, 0);
      }
    }
  }

  addDefaultsDatesForYear() {
    this.spinnerService.show();
    this.rest.addDefaultsDatesForYear(this.selectedYear).subscribe(result => {
      if (result) {
        this.grid.refreshData(false);
      }
      this.spinnerService.hide();
    });
  }

  public save() {
    if (this.addDate != null) {
      this.spinnerService.show();
      this.rest.save(this.addDate.value.toJSON(), this.descriptionText).subscribe(result => {
        if (result) {
          this.closeModal();
          this.grid.refreshData(false);
          this.spinnerService.hide();
        }
      });
    }
  }

  public closeModal() {
    this.modal.close();
    this.descriptionText = '';
  }

  onRowAdd() {
    this.modal.title = "Dodaj dzień świateczny";
    this.modal.open();
  }

  onRowDelete(row: HolidayCalendar) {
    sweetAlert('Czy chcesz usunąć wpis nieobecności?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    }).then((value) => {
      switch (value) {
        case 'yes':
          this.spinnerService.show();
          this.rest.delete(row.id).subscribe(result => {
            if (result) {
              this.grid.refreshData(false);
            }
            this.spinnerService.hide();
          });
          break;
      }
    });
  }

  private filter() {
    this.mainFilter = new Array();
    var month = this.selectedMonth == null ? 0 : this.selectedMonth - 1;
    let fromDate = new Date(this.selectedYear, month, 1);
    let toDate = new Date(this.selectedYear, this.selectedMonth || 12, 0);
    this.setFilter('FromDate', fromDate.toJSON());
    this.setFilter('ToDate', toDate.toJSON());
    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  public filterByFullDates() {
    if (this.fromDate.value != null) {
      this.setFilter('FromDate', this.fromDate.value.toJSON());
    }
    if (this.toDate.value != null) {
      this.setFilter('ToDate', this.toDate.value.toJSON());
    }
    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  public clearFilter() {
    this.selectedYear = new Date().getFullYear();
    this.selectedYear = null;
    this.filter();
  }

  private setFilter(internalName: string, filterValue: any) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }


  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 768) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }
}


